import { useSelector } from 'react-redux';
import { replaceTokensInString } from '@app/utils';
import useHelpCenterLink from '../../../csr-landing/hooks/useHelpCenterLink';
import endpoints from '@app/constants/endpoints';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { useTranslation } from 'react-i18next';

function ContactUsDealerInformationFooter() {
  const [t] = useTranslation();
  const { getHelpCenterURL } = useHelpCenterLink();

  const helpCenterEnabled = useSelector(
    s => s.featureFlag?.PCCCustomerSupportHelpCenter
  );
  const seoURL = useSelector(s => s.dealer?.seoURL);
  const isCatCorp = useSelector(s => s.common?.isCatCorp);

  const showHelpCenter = isCatCorp || helpCenterEnabled;
  const isRedirectedToNewHelpCenter = () => {
    return showHelpCenter;
  };

  const linkCatHelpCenterV1 = replaceTokensInString(
    endpoints.FOOTER_LINK_HELP_CENTER,
    seoURL
  );

  return (
    <div className="cat-u-padding-md">
      <CatTextLink
        variant="link"
        href={
          isRedirectedToNewHelpCenter()
            ? getHelpCenterURL()
            : linkCatHelpCenterV1
        }
        target={isRedirectedToNewHelpCenter() ? '_blank' : '_self'}
        type="button"
        size="sm"
      >
        {t('VISIT_HELP_CENTER_CTA')}
      </CatTextLink>
    </div>
  );
}

export default ContactUsDealerInformationFooter;
